module.exports = __webpack_public_path__ + "img/logo.6050eac6.png";